export const PRACTICE_SOCIAL_FIELDS = [
  ["website", "Website"],
  ["facebook", "Facebook"],
  ["instagram", "Instagram"],
  ["tiktok", "TikTok"],
  ["linkedin", "LinkedIn"],
  ["twitter", "Twitter"],
  ["youtube", "YouTube"]
] as const

export function normalizeSocialUrl(value: string | null | undefined): string {
  const s = (value ?? "").trim()
  if (!s) return ""

  const schemeMatch = s.match(/^(https?):\/\//i)
  const scheme = schemeMatch?.[1]
  if (scheme) {
    return `${scheme.toLowerCase()}://${s.slice(schemeMatch[0].length)}`
  }

  if (/^[a-z][a-z0-9+\-.]*:/i.test(s)) return s
  if (s.includes(".") && !/\s/.test(s)) return `https://${s}`
  return s
}

export function socialUrlValidationMessage(label: string, value: string | null | undefined): string | null {
  const normalized = normalizeSocialUrl(value)
  if (!normalized) return null

  try {
    const url = new URL(normalized)
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return `Please paste a full ${label} link (e.g. https://${label.toLowerCase()}.com/...)`
    }
    return null
  } catch {
    return `Please paste a full ${label} link (e.g. https://${label.toLowerCase()}.com/...)`
  }
}

export function normalizePracticeSocialFields<T extends Record<string, unknown>>(
  details: T
): { details: T; error: string | null } {
  const next = { ...details }
  for (const [key, label] of PRACTICE_SOCIAL_FIELDS) {
    const current = next[key]
    if (typeof current !== "string") continue

    const error = socialUrlValidationMessage(label, current)
    if (error) return { details: next, error }
    ;(next as Record<string, unknown>)[key] = normalizeSocialUrl(current)
  }
  return { details: next, error: null }
}
